import React from 'react';
import _ from 'lodash';
import { Segment, Button } from 'semantic-ui-react';
import PayingMembersTable from './PayingMembersTable';
import { useQuery } from '@apollo/react-hooks';
import QUERY_CURRENT_USER from '../../queries/user';
import Loading from '../Loading/index';

const PayingMembers = () => {
	const childRef = React.useRef(null);
	const { data, loading } = useQuery(QUERY_CURRENT_USER);
	return (
		<div className="animated fadetwoIn dnp-page">
			<Segment.Group stacked={true}>
				<Segment color='green' className="tableHeaderContainer">
					<div></div>
					<h2>Paying Members</h2>
					<Button basic onClick={() => childRef.current.refresh()}>
						<i className="fa fa-refresh fa-lg filterIcon" aria-hidden="true"></i>
					</Button>
				</Segment>
				<Segment placeholder>
					{loading ? <Loading /> : <PayingMembersTable ref={childRef} parent={_.get(data, 'user.id')} /> }
				</Segment>
			</Segment.Group>
		</div>
	);
};

export default PayingMembers;